var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-padding" },
    [
      _vm.items.length || _vm.isSearchResult
        ? [
            _c(
              "div",
              { staticClass: "round-borders no-scroll" },
              [
                _c(
                  "q-toolbar",
                  { staticClass: "justify-between", attrs: { color: "white" } },
                  [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("q-search", {
                          staticClass: "q-mr-lg no-shadow",
                          attrs: {
                            color: "white",
                            "inverted-light": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.filter,
                            callback: function($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-auto" },
                      [
                        _vm.selectedItems.length
                          ? [
                              _c(
                                "q-btn",
                                {
                                  staticClass: "items-toolbar__actions",
                                  attrs: {
                                    icon: "more_vert",
                                    color: "grey-9",
                                    flat: "",
                                    round: "",
                                    dense: ""
                                  }
                                },
                                [
                                  _c(
                                    "q-popover",
                                    [
                                      _c(
                                        "q-list",
                                        {
                                          staticClass: "no-border",
                                          attrs: { link: "" }
                                        },
                                        [
                                          _vm.selectedItems.length === 1
                                            ? _c(
                                                "q-item",
                                                {
                                                  directives: [
                                                    {
                                                      name: "close-overlay",
                                                      rawName: "v-close-overlay"
                                                    }
                                                  ],
                                                  nativeOn: {
                                                    click: function($event) {
                                                      _vm.handleEdit(null)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("q-item-side", {
                                                    attrs: { icon: "edit" }
                                                  }),
                                                  _c("q-item-main", {
                                                    attrs: {
                                                      label: _vm.$t("edit")
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "q-item",
                                            {
                                              directives: [
                                                {
                                                  name: "close-overlay",
                                                  rawName: "v-close-overlay"
                                                }
                                              ],
                                              nativeOn: {
                                                click: function($event) {
                                                  _vm.handleRemove(null)
                                                }
                                              }
                                            },
                                            [
                                              _c("q-item-side", {
                                                attrs: { icon: "delete" }
                                              }),
                                              _c("q-item-main", {
                                                attrs: {
                                                  label: _vm.$t("remove")
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ]
                ),
                _c("q-table", {
                  staticClass: "bg-white no-shadow no-border-radius",
                  attrs: {
                    data: _vm.mappedItems,
                    columns: _vm.columns,
                    filter: _vm.filter,
                    selection: _vm.user.isUserOfActiveTeam()
                      ? "multiple"
                      : "none",
                    selected: _vm.selectedItems,
                    "rows-per-page-options": _vm.rowsPerPageOptions,
                    "row-key": "id",
                    pagination: _vm.pagination,
                    loading: !_vm.itemsLoaded,
                    "table-class": "items-table",
                    "binary-state-sort": ""
                  },
                  on: {
                    "update:selected": function($event) {
                      _vm.selectedItems = $event
                    },
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    },
                    request: _vm.handleRequest
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "body-cell-actions",
                      fn: function(props) {
                        return _c(
                          "q-td",
                          { attrs: { props: props } },
                          [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  icon: "more_vert",
                                  color: "grey-7",
                                  flat: "",
                                  round: "",
                                  dense: ""
                                }
                              },
                              [
                                _c(
                                  "q-popover",
                                  [
                                    _c(
                                      "q-list",
                                      {
                                        staticClass: "no-border",
                                        attrs: { link: "" }
                                      },
                                      [
                                        _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.handleEdit(props.row)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-side", {
                                              attrs: { icon: "edit" }
                                            }),
                                            _c("q-item-main", {
                                              attrs: { label: _vm.$t("edit") }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-overlay",
                                                rawName: "v-close-overlay"
                                              }
                                            ],
                                            nativeOn: {
                                              click: function($event) {
                                                _vm.handleRemove(props.row)
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-side", {
                                              attrs: { icon: "delete" }
                                            }),
                                            _c("q-item-main", {
                                              attrs: { label: _vm.$t("remove") }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        : [
            _c(
              "div",
              {
                staticClass: "row justify-center items-center col-grow q-pt-lg"
              },
              [
                _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("assets/emptystates/items_empty.svg")
                      }
                    }),
                    _c("h6", { staticClass: "q-my-md text-faded" }, [
                      _vm._v(_vm._s(_vm.$t("items_empty")))
                    ]),
                    _c(
                      "q-btn",
                      {
                        directives: [{ name: "is-user", rawName: "v-is-user" }],
                        staticClass: "q-mt-lg",
                        attrs: { color: "primary", outline: "" },
                        on: { click: _vm.handleCreateItem }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("add_item")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ],
      _c("add-items-modal", {
        directives: [{ name: "is-user", rawName: "v-is-user" }],
        ref: "createModal"
      }),
      _c("update-items-modal", { ref: "updateModal" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }